/* VigorX Cart — gift race-fix REMOVED (no gift offer in HR). Releasit buy button runs natively, no click interception. */

/* ── VX Testimonials Swiper ── */
;(function vxTestimonials() {
  if (window.__vxTestiLoaded) return;
  window.__vxTestiLoaded = true;

  function initSwiper(section) {
    const track   = section.querySelector('[data-testi-track]');
    const outer   = section.querySelector('[data-testi-outer]');
    const prevBtn = section.querySelector('[data-testi-prev]');
    const nextBtn = section.querySelector('[data-testi-next]');
    const dotsWrap = section.querySelector('[data-testi-dots]');
    if (!track) return;

    const cards = Array.from(track.children);
    if (!cards.length) return;

    let current = 0;
    let perView = 3;
    let total   = 1;
    let autoTimer = null;

    // Autoplay interval is per-section so a template can tune it; 0 disables.
    const AUTO_MS = parseInt(section.dataset.vxAutoplay, 10) || 5000;
    // Never auto-advance for someone who asked for reduced motion.
    const reduceMotion = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let userHold = false;      // true while the shopper is actively swiping
    let holdTimer = null;

    // <=640px uses native CSS scroll-snap (set in the stylesheet); JS only drives
    // the transform-based slider on tablet/desktop so the two never fight.
    function isMobile() { return window.innerWidth <= 640; }

    function compute() {
      perView = window.innerWidth >= 1024 ? 3 : 2;
      total   = Math.max(1, cards.length - perView + 1);
      if (current > total - 1) current = total - 1;
      if (current < 0) current = 0;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (isMobile()) return;
      for (let i = 0; i < total; i++) {
        const dot = document.createElement('button');
        dot.className = 'vx-testi__dot' + (i === current ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Opinia ' + (i + 1));
        dot.addEventListener('click', function() { goTo(i); });
        dotsWrap.appendChild(dot);
      }
    }

    function getCardWidth() {
      const gap = 16;
      const outerW = outer ? outer.offsetWidth : track.offsetWidth;
      return (outerW - gap * (perView - 1)) / perView + gap;
    }

    function updateDots() {
      if (!dotsWrap) return;
      Array.from(dotsWrap.children).forEach(function(d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= total - 1;
    }

    function goTo(idx) {
      if (isMobile()) return;
      current = Math.max(0, Math.min(idx, total - 1));
      track.style.transform = 'translateX(-' + (current * getCardWidth()) + 'px)';
      updateDots();
      updateArrows();
      resetAuto();
    }

    // Mobile is a native scroll-snap scroller, so advancing there means
    // scrolling the track rather than transforming it. Desktop keeps the
    // transform slider. Either way autoplay stops while the shopper is
    // interacting and while the tab is hidden.
    // selfScrolling tells the scroll listener to ignore the scroll WE just
    // started. Without it every autoplay step looked like a manual swipe, called
    // holdAuto() and paused the carousel -- so it advanced exactly once and then
    // sat still for the rest of the visit.
    let selfScrolling = false;
    let selfScrollTimer = null;

    function advanceMobile() {
      const first = cards[0];
      if (!first) return;
      const step = first.getBoundingClientRect().width + 12; // 12px gap on mobile
      const maxLeft = track.scrollWidth - track.clientWidth - 2;
      const next = track.scrollLeft >= maxLeft ? 0 : track.scrollLeft + step;
      selfScrolling = true;
      clearTimeout(selfScrollTimer);
      // scrollend is not everywhere yet, so a timeout closes the window too.
      selfScrollTimer = setTimeout(function () { selfScrolling = false; }, 900);
      track.scrollTo({ left: next, behavior: 'smooth' });
    }

    function resetAuto() {
      clearInterval(autoTimer);
      autoTimer = null;
      if (reduceMotion || !AUTO_MS || userHold || document.hidden) return;
      if (isMobile()) {
        if (cards.length <= 1) return;
        autoTimer = setInterval(advanceMobile, AUTO_MS);
        return;
      }
      if (total <= 1) return;
      autoTimer = setInterval(function() {
        goTo(current >= total - 1 ? 0 : current + 1);
      }, AUTO_MS);
    }

    function holdAuto() {
      userHold = true;
      clearInterval(autoTimer);
      autoTimer = null;
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function() { userHold = false; resetAuto(); }, 4000);
    }

    // Switch cleanly between native-scroll (mobile) and transform-slider (desktop)
    function layout() {
      compute();
      if (isMobile()) {
        track.style.transform = '';
        if (dotsWrap) dotsWrap.innerHTML = '';
        resetAuto();               // mobile autoplays too, via native scroll
        return;
      }
      buildDots();
      track.style.transform = 'translateX(-' + (current * getCardWidth()) + 'px)';
      updateDots();
      updateArrows();
      resetAuto();
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    // Pause on hover (desktop only)
    section.addEventListener('mouseenter', function() { clearInterval(autoTimer); });
    section.addEventListener('mouseleave', function() { resetAuto(); });

    // ...and the same courtesy for keyboard users, who cannot hover: moving
    // focus into the carousel holds it still, leaving stops the hold.
    section.addEventListener('focusin', function () { userHold = true; clearInterval(autoTimer); autoTimer = null; });
    section.addEventListener('focusout', function (e) {
      if (section.contains(e.relatedTarget)) return;
      userHold = false; resetAuto();
    });

    // Touch swipe (tablet) + hand control back to the shopper on any manual swipe
    var touchStartX = 0;
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      holdAuto();
    }, { passive: true });
    track.addEventListener('touchend', function(e) {
      if (isMobile()) return;
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });
    // A wheel/trackpad or scrollbar drag on the mobile scroller counts as manual too.
    track.addEventListener('scroll', function () {
      if (selfScrolling) return;       // our own autoplay step, not a shopper
      holdAuto();
    }, { passive: true });

    layout();

    // Don't burn cycles animating a tab nobody is looking at.
    function onVisibility() { if (document.hidden) { clearInterval(autoTimer); autoTimer = null; } else { resetAuto(); } }
    document.addEventListener('visibilitychange', onVisibility);

    // Re-layout on resize / orientation change
    var resizeTimer;
    function onResize() { clearTimeout(resizeTimer); resizeTimer = setTimeout(layout, 200); }
    window.addEventListener('resize', onResize, { passive: true });

    // Release every timer and listener so nothing keeps the page alive in memory
    // or blocks the back/forward cache.
    // Release timers when the page is put away. NOT {once:true}: a back/forward
    // cache restore reuses this very page, so a one-shot teardown would leave the
    // carousel permanently dead on the second visit. pageshow restarts it.
    window.addEventListener('pagehide', function () {
      clearInterval(autoTimer); autoTimer = null;
      clearTimeout(holdTimer); clearTimeout(selfScrollTimer);
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { userHold = false; resetAuto(); }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vx-testimonials]').forEach(initSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();

/* ── VX Description CTA → buy-box smooth scroll ──
   Routes every in-description CTA to the buy box (Add to cart + Buy Now).
   Matches explicit anchors plus any clickable whose class carries a “…-cta”
   token — covers every per-product CTA naming across the catalog
   (vx*-cta: vxred/vxcob/vxbom/vxgel/vxg/vxsum/vxhon/vxlov/vxblk/vxsup/vxvid/
   vxtp/vxcb, AND fnx-*-cta: fnx-skg/fnx-cen/fnx-c100), so no product — and no
   typo in a product's own inline handler (e.g. ".vxred-c ta") — can dead-click. */
;(function vxScrollToOrder() {
  if (window.__vxOrderScrollLoaded) return;
  window.__vxOrderScrollLoaded = true;

  var STATIC_SELECTOR = 'a[href="#order"], a[href$="#order"], [data-vx-scroll="order"]';
  var CTA_CLASS = /(?:^|\s)[a-z][a-z0-9_-]*-cta(?:\s|$)/i;

  function findBuyBox() {
    // Prefer the explicit anchor; fall back to the product form (what the inline
    // scripts target) then the info column, so it never dead-clicks.
    return document.querySelector('product-form, .product-form') ||
           document.getElementById('order') ||
           document.querySelector('product-info .product__info-container, .product__info-container, product-info');
  }

  function findTrigger(node) {
    var el = node.closest ? node.closest(STATIC_SELECTOR + ', a, button') : null;
    if (!el) return null;
    if (el.matches(STATIC_SELECTOR)) return el;
    // Generic <a>/<button> hits only count as CTAs if they carry a …-cta class.
    return CTA_CLASS.test(el.getAttribute('class') || '') ? el : null;
  }

  // ONE delegated listener — survives AJAX re-renders, no per-node leaks.
  document.addEventListener('click', function (e) {
    var trigger = findTrigger(e.target);
    if (!trigger) return;

    var target = findBuyBox();
    if (!target) return; // graceful: nothing to scroll to → leave default behavior

    e.preventDefault();
    var header = document.querySelector('.section-header, header, .shopify-section-header-group');
    var offset = (header ? header.offsetHeight : 80) + 12;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  }, { passive: false });
})();
